import type { ShortcutBinding } from 'components/KeyboardShortcuts/ShortcutListener';

export function buildShortcutBindings(
  shortcuts: Array<{
    combo: string;
    description: string;
    allowInInputs?: boolean;
    action?: string;
  }>,
  handlers: Record<string, (() => void) | undefined>
): ShortcutBinding[] {
  return shortcuts
    .map((s): ShortcutBinding | null => {
      const handlerKey = s.action || s.combo;
      const handler = handlers[handlerKey];
      if (!handler) return null;
      return {
        combo: s.combo,
        handler: () => handler(),
        allowInInputs: s.allowInInputs ?? false,
        preventDefault: true,
        stopPropagation: false,
        enabled: true,
      };
    })
    .filter((binding): binding is ShortcutBinding => binding !== null);
}
